/* AUTO-GÉNÉRÉ par ma-discount-app/scripts/gen-lot-prices.mjs — NE PAS ÉDITER À LA MAIN.
 * Source : moulin-de-launay/docs/groupes-cures.csv (statut = web). Régénérer : node scripts/gen-lot-prices.mjs
 * Clé = SKU Shopify (= réf MA). lot4 = lot « 3+1 » (4 flacons). Un palier n'existe que si défini.
 * Lu par les cartes de lots de la fiche produit (chantier C). Mêmes chiffres que la Function. */
window.MA_LOT_PRICES = {
  "ARPA": { "unit": 12.90, "lot2": 19.90, "lot4": 34.90 },
  "ARTI": { "unit": 12.90, "lot2": 19.90, "lot4": 34.90 },
  "ARTI4": { "unit": 15.90, "lot2": 23.90, "lot4": 39.90 },
  "BIFI": { "unit": 12.90, "lot2": 19.90 },
  "CANA1": { "unit": 24.90, "lot2": 44.90, "lot4": 69.90 },
  "CICAT": { "unit": 12.90, "lot2": 19.90 },
  "CIRC": { "unit": 12.90, "lot2": 19.90, "lot4": 34.90 },
  "CLAIR": { "unit": 12.90, "lot2": 19.90 },
  "CURC1": { "unit": 15.90, "lot2": 23.90, "lot4": 39.90 },
  "CYST": { "unit": 12.90, "lot2": 19.90 },
  "DETNAT": { "unit": 16.90, "lot2": 29.90, "lot4": 49.90 },
  "DETOX": { "unit": 16.90, "lot2": 24.90, "lot4": 39.90 },
  "DIGES": { "unit": 10.90, "lot2": 17.90 },
  "DUO": { "unit": 13.90, "lot2": 19.90 },
  "EFFE": { "unit": 8.60, "lot4": 29.40 },
  "F140": { "unit": 14.90, "lot2": 22.90, "lot4": 37.90 },
  "F141": { "unit": 14.90, "lot4": 36.90 },
  "F948": { "unit": 12.90, "lot2": 19.90 },
  "FENO": { "unit": 11.90, "lot2": 18.90 },
  "G140": { "unit": 12.90, "lot2": 19.90 },
  "G141": { "unit": 11.90, "lot4": 34.90 },
  "GIN66": { "unit": 12.90, "lot2": 19.90, "lot4": 34.90 },
  "GUGC66": { "unit": 14.90, "lot2": 22.90 },
  "H1BO": { "unit": 13.90, "lot2": 19.90 },
  "HARP66": { "unit": 12.90, "lot2": 19.90, "lot4": 34.90 },
  "HPRO": { "unit": 13.90, "lot2": 19.90, "lot4": 36.90 },
  "KITO": { "unit": 15.90, "lot2": 23.90, "lot4": 39.90 },
  "LAX": { "unit": 11.90, "lot2": 18.90 },
  "LECI": { "unit": 11.90, "lot2": 18.90, "lot4": 34.90 },
  "LUMB": { "unit": 11.90, "lot2": 18.90 },
  "MACNB": { "unit": 12.90, "lot2": 19.90, "lot4": 34.90 },
  "MAGB": { "unit": 13.90, "lot2": 19.90, "lot4": 36.90 },
  "MAVE": { "unit": 11.90, "lot2": 19.90 },
  "MURA": { "unit": 11.90, "lot2": 18.90 },
  "N580": { "unit": 12.90, "lot2": 19.90, "lot4": 34.90 },
  "N589": { "unit": 11.90, "lot2": 18.90 },
  "OMEG": { "unit": 13.90, "lot2": 19.90, "lot4": 36.90 },
  "PATN": { "unit": 11.90, "lot2": 18.90 },
  "PREM1": { "unit": 14.90, "lot2": 22.90, "lot4": 37.90 },
  "PROP": { "unit": 9.90, "lot2": 15.90, "lot4": 29.90 },
  "PROS66": { "unit": 14.90, "lot2": 22.90, "lot4": 37.90 },
  "PROSTA1": { "unit": 15.90, "lot2": 23.90, "lot4": 39.90 },
  "REQ66": { "unit": 14.90, "lot2": 22.90, "lot4": 37.90 },
  "RETI": { "unit": 13.90, "lot2": 19.90 },
  "ROL": { "unit": 12.90, "lot2": 19.90 },
  "SER66": { "unit": 14.90, "lot2": 22.90, "lot4": 37.90 },
  "SILV3": { "unit": 14.90, "lot2": 22.90, "lot4": 37.90 },
  "SLIM": { "unit": 11.90, "lot2": 18.90 },
  "SOME": { "unit": 13.90, "lot2": 19.90, "lot4": 36.90 },
  "SUED": { "unit": 19.90, "lot2": 34.90, "lot4": 59.70 },
  "SXC10": { "unit": 16.90, "lot2": 29.90, "lot4": 49.90 },
  "TIVIA": { "unit": 14.90, "lot2": 22.90, "lot4": 37.90 },
  "TUGC": { "unit": 13.90, "lot2": 19.90, "lot4": 36.90 },
  "TURBO": { "unit": 16.90, "lot2": 29.90, "lot4": 49.90 },
  "VENA": { "unit": 12.90, "lot2": 19.90, "lot4": 34.90 },
  "VIG1": { "unit": 15.90, "lot2": 23.90, "lot4": 39.90 },
  "VISU": { "unit": 13.90, "lot2": 19.90, "lot4": 36.90 },
};

/* PROMOS PAR CODE — opérations dédiées à un produit (remise appliquée SUR le prix de lot).
 * Clé = code avantage, valeur = { sku remisé, % retiré en entier }. Lue par les cartes de
 * lots de la fiche produit pour afficher le prix réellement facturé. MÊME source que la
 * Function (scripts/gen-lot-prices.mjs) : les deux ne peuvent pas diverger.
 * Arrondi : chaque palier est remisé puis arrondi au centime, EN CENTIMES ENTIERS —
 * appliquer la remise au total donnerait un centime d'écart sur les quantités mixtes, et
 * la multiplier en flottant arrondirait 29,90 et 49,90 en sens opposés. */
window.MA_LOT_PROMOS = {
  "DETOX35": { "sku": "DETNAT", "off": 35 },
};
